export const convertToGraphQl = (name, filter, items, sort = null, pageNumber, perPage = 10, dates, dateKey) => {
  if (dates != null) {
    if (filter == null) {
      filter = {}
    }
    filter["_operators"] = createDateFilter(dates, dateKey)
  }

  items.push("_id")

  let q = `
    {
        ${name}(page:${pageNumber},perPage:${perPage},sort:${sort},filter:${JSON.stringify(filter)}){
          count
          pageInfo {
            pageCount
            itemCount
            hasNextPage
            hasPreviousPage
          }
          items {
            ${items.join("\n")}
          }
        }
      }      
    `
  return q.replace(/"(\w+)"\s*:/g, '$1:')
}

const createDateFilter = (dates, dateKey) => {
  let d = {}
  d[dateKey] = { gte: dates[0].toISOString(), lte: dates[1].toISOString() }
  return d
}


export const appendKey = (data) => {
  for (let item of data) {
    item["key"] = item["_id"]
  }
}

export const createGraphQlFilters = (filters) => {
  let allFilters = []
  for (let key in filters) {
    let temp = []
    let l = filters[key]
    if (l && l.length != 0) {
      for (let item of l) {
        let m = {}
        m[key] = item
        temp.push(m)
      }
      allFilters.push({ OR: temp })
    }
  }
  if (allFilters.length == 0) {
    return null
  }
  return { "AND": allFilters }
}

export const createSortOrder = (sortObj) => {
  if (sortObj == null || sortObj["column"] == null || sortObj["field"] == "returns" || sortObj["field"] == "ci" || sortObj["field"] == 'startDate') {
    return null
  }
  let key = sortObj["columnKey"].toUpperCase()
  if (sortObj['order'] == "ascend") {
    key = key + "_ASC"
  } else if (sortObj['order'] == "descend") {
    key = key + "_DESC"
  }
  return key
}